import {
    Icon20CloudOutline,
    Icon20SmileAddOutline,
    Icon20UsersOutline,
    Icon24CloudOutline,
    Icon24SmileAddOutline,
    Icon24UsersOutline,
} from '@vkontakte/icons';
import React from 'react';
import { familyRouteTextDisabled } from 'reactApp/appHelpers/featuresHelpers/features/familyFunctions';

import { type FamilyFeatureProps, FeaturesColor } from './FamilyPromo.types';

export const featuresList: FamilyFeatureProps[] = [
    {
        color: FeaturesColor.blue,
        compactColor: FeaturesColor.orange,
        icon: <Icon24SmileAddOutline />,
        compactIcon: <Icon20SmileAddOutline />,
        title: !familyRouteTextDisabled ? '+3 участника' : '+3 места',
        text: !familyRouteTextDisabled
            ? 'Подпиской можно пользоваться вчетвером'
            : 'Приглашайте близких в Mail Space в любое время. Это бесплатно',
        id: 'place',
    },
    {
        color: FeaturesColor.green,
        compactColor: FeaturesColor.darkGreen,
        icon: <Icon24CloudOutline />,
        compactIcon: <Icon20CloudOutline />,
        title: !familyRouteTextDisabled ? '1 терабайт памяти' : 'Платите столько же',
        text: !familyRouteTextDisabled
            ? 'Целый терабайт для семейных фото'
            : 'Все участники пользуются подпиской, при этом её стоимость не меняется',
        id: 'price',
    },
    {
        color: FeaturesColor.purple,
        compactColor: FeaturesColor.violet,
        icon: <Icon24UsersOutline />,
        compactIcon: <Icon20UsersOutline />,
        title: !familyRouteTextDisabled ? 'Общее пространство' : 'У каждого свой аккаунт',
        text: !familyRouteTextDisabled
            ? 'Семейные папки и альбомы для важных дел семьи'
            : 'А выгода общая: никакой рекламы и больше места для файлов',
        id: 'accounts',
    },
];
